export default "/dist/files/icon_coffre_fort_blanc.45953fafcdc101aea66b741464439088.svg";